function pickTranslation(translations, locale) {
  if (!translations || typeof translations !== "object") {
    return "";
  }

  if (translations[locale]) {
    return translations[locale];
  }

  const base = String(locale || "").split("-")[0];
  const matchedKey = Object.keys(translations).find(
    (key) => key === base || key.startsWith(`${base}-`) || key.startsWith(base),
  );

  if (matchedKey) {
    return translations[matchedKey];
  }

  return Object.values(translations).find(Boolean) ?? "";
}

export function mapMainBoxesToPortalTeasers(mainBoxes, locale) {
  if (!Array.isArray(mainBoxes)) {
    return [];
  }

  return mainBoxes
    .slice(0, 3)
    .map((box, index) => {
      const imageSrc = pickTranslation(box.image, locale);
      const url = pickTranslation(box.url, locale);
      const title = pickTranslation(box.name, locale);

      return {
        id: box.id ?? `main-box-${index}`,
        imageSrc,
        url: url || null,
        title: title || null,
        newTab: Boolean(box.new_tab),
      };
    })
    .filter((box) => box.imageSrc);
}
